import React from "react";
import search from "../../assets/images/Search.svg";
import fligths from "../../assets/images/Flights.svg";
import aircraft from "../../assets/images/Aircraft.svg";
import airport from "../../assets/images/Airport.svg";
import total from "../../assets/images/Total.svg";
import imports from "../../assets/images/Import.svg";
import { Link, Navigate, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import dashboard from "../../assets/images/Dashboard.svg";
import chevron from "../../assets/images/chevron.svg";
import Slide from "@mui/material/Slide";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PaymentsIcon from '@mui/icons-material/Payments';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  getActiveTab,
  getSidebarStatus,
  setSidebarShow,
} from "../../store/slices/layout-slice";
import { useAppDispatch, useAppSelector } from "../../hooks/app";

function AdminLinks() {


  const activeTab = useAppSelector(getActiveTab);
  const sidebarStatus = useAppSelector(getSidebarStatus);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <>
       <li 
       onClick={()=>navigate("/admin")}
       style={{ display: "flex", gap: "10px" }}>
            <img src={dashboard} alt="Dashboard Logo" />
            <Link to="/admin">Dashboard</Link>
          </li>
      <li
        onClick={()=>navigate("/admin/users")}
        style={{ display: "flex", gap: "10px" }}
      >
       <PeopleAltIcon style={{color:"white", height:"18px",width:"18px"}}/>
        <span>Users</span>
      </li>
      <li
        style={{ display: "flex", gap: "10px" }}
        onClick={()=>navigate("/admin/user-groups-list")}
      >
        <GroupAddIcon style={{color:"white", height:"18px",width:"18px"}}/>
        <span>User Groups</span>
      </li>
      <li
        style={{ display: "flex", gap: "10px" }}
        onClick={()=>navigate("/admin/flights")}
      >
        <img src={fligths} alt="Flights Logo" />
        <span>Flights</span>
      </li>
      <li
        style={{ display: "flex", gap: "10px" }}
      >
        <PaymentsIcon  style={{color:"white", height:"18px",width:"18px"}}/>
        <span>Payment</span>
      </li>  
      <li style={{ display: "flex", gap: "10px" }}>
        <SettingsIcon style={{color:"white", height:"18px",width:"18px"}} />
        <span>Settings</span>
      </li>
    </>
  );
}

export default AdminLinks;
